import React, { useState, useRef, useEffect } from 'react';
import AOS from 'aos';
import '../styles/pages/Jerry.css';
import Navbar from '../components/layout/Navbar';

// Import images
import Banner from '../components/assets/Jerry/Jerry_Banner.png';
import Maze from '../components/assets/Jerry/Maze.png';
import UserInterviews from '../components/assets/Jerry/User Interviews.png';
import Sprig from '../components/assets/Jerry/Sprig.png';
import FeaturePlanning from '../components/assets/Jerry/Feature Planning.png';
import InformationArchitecture from '../components/assets/Jerry/Information Architecture.png';
import DesignSystem from '../components/assets/Jerry/Design System.png';

// Feature images
import HomepageUf from '../components/assets/Jerry/Homepage_uf.png';
import HomepageWf from '../components/assets/Jerry/Homepage_wf.png';
import MetadataUf from '../components/assets/Jerry/Metadata_uf.png';
import MetadataWf from '../components/assets/Jerry/Metadata_wf.gif';
import MaterialUf from '../components/assets/Jerry/Material_uf.png';
import MaterialWf from '../components/assets/Jerry/Material_wf.gif';
import CollaboratorsUf from '../components/assets/Jerry/Collaborators_uf.png';
import CollaboratorWf from '../components/assets/Jerry/Collaborator_wf.gif';
import FlowUf from '../components/assets/Jerry/Flow_uf.png';
import FlowWf from '../components/assets/Jerry/Flow_wf.gif';
import ParticipantsUf from '../components/assets/Jerry/Participants_uf.png';
import ParticipantsWf from '../components/assets/Jerry/participants_wf.gif';
import RolesUf from '../components/assets/Jerry/Roles_uf.png';
import RolesWf from '../components/assets/Jerry/Roles_wf.gif';
import TaskManagementWf from '../components/assets/Jerry/task_management_wf.gif';
import CalendarWf from '../components/assets/Jerry/Calendar_wf.gif';

const Jerry = () => {
  const [selectedFeature, setSelectedFeature] = useState('Home page');
  const [activeTab, setActiveTab] = useState('wireframes');
  const [currentCompetitor, setCurrentCompetitor] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [expandedFeature, setExpandedFeature] = useState('Home page');
  const [isMobile, setIsMobile] = useState(false);
  const progressRef = useRef(null);
  const progressMobileRef = useRef(null);

  const features = [
    {
      name: 'Home page',
      userflow: HomepageUf,
      figjamLink: 'https://www.figma.com/board/kLqcXAEZtQ7mgJ8zmlX1wI/Jerry_publish?node-id=78-464&t=vHJHqgk8fIXj9ZGn-4',
      wireframe: HomepageWf
    },
    {
      name: 'Metadata',
      userflow: MetadataUf,
      figjamLink: 'https://www.figma.com/board/kLqcXAEZtQ7mgJ8zmlX1wI/Jerry_publish?node-id=78-562&t=vHJHqgk8fIXj9ZGn-4',
      wireframe: MetadataWf
    },
    {
      name: 'Material',
      userflow: MaterialUf,
      figjamLink: 'https://www.figma.com/board/kLqcXAEZtQ7mgJ8zmlX1wI/Jerry_publish?node-id=78-507&t=vHJHqgk8fIXj9ZGn-4',
      wireframe: MaterialWf
    },
    {
      name: 'Collaborators',
      userflow: CollaboratorsUf,
      figjamLink: 'https://www.figma.com/board/kLqcXAEZtQ7mgJ8zmlX1wI/Jerry_publish?node-id=78-428&t=vHJHqgk8fIXj9ZGn-4',
      wireframe: CollaboratorWf
    },
    {
      name: 'Flow',
      userflow: FlowUf,
      figjamLink: 'https://www.figma.com/board/kLqcXAEZtQ7mgJ8zmlX1wI/Jerry_publish?node-id=78-645&t=vHJHqgk8fIXj9ZGn-4',
      wireframe: FlowWf
    },
    {
      name: 'Participants and Groups',
      userflow: ParticipantsUf,
      figjamLink: 'https://www.figma.com/board/kLqcXAEZtQ7mgJ8zmlX1wI/Jerry_publish?node-id=78-490&t=vHJHqgk8fIXj9ZGn-4',
      wireframe: ParticipantsWf
    },
    {
      name: 'Roles and Permissions',
      userflow: RolesUf,
      figjamLink: 'https://www.figma.com/board/kLqcXAEZtQ7mgJ8zmlX1wI/Jerry_publish?node-id=78-490&t=vHJHqgk8fIXj9ZGn-4',
      wireframe: RolesWf
    },
    {
      name: 'Task Management',
      userflow: null,
      figjamLink: null,
      wireframe: TaskManagementWf
    },
    {
      name: 'Calendar',
      userflow: null,
      figjamLink: null,
      wireframe: CalendarWf
    }
  ];

  const selectedFeatureData = features.find(f => f.name === selectedFeature);

  const competitors = [
    { name: 'Maze', image: Maze },
    { name: 'User Interviews', image: UserInterviews },
    { name: 'Sprig', image: Sprig }
  ];

  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('.jerry-content section, .jerry-content > div[data-aos]');
      let viewed = 0;
      const buffer = window.innerHeight * 0.3;
      sections.forEach(section => {
        const rect = section.getBoundingClientRect();
        if (rect.top < window.innerHeight - buffer) viewed++;
      });
      const percent = Math.max(0, Math.min(1, viewed / 8)); // Adjust number based on total sections
      if (progressRef.current) {
        progressRef.current.style.height = `${percent * 100}%`;
      }
      if (progressMobileRef.current) {
        if (window.innerWidth <= 700) {
          progressMobileRef.current.style.width = `${percent * 100}%`;
        }
      }
    };
    
    // Prevent automatic scrolling on page load
    window.scrollTo(0, 0);
    
    window.addEventListener('scroll', handleScroll);
    // Delay the initial handleScroll call to prevent immediate scroll behavior
    setTimeout(() => {
      handleScroll();
    }, 100);
    
    AOS.refresh();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    AOS.init({ once: false, duration: 700, easing: 'ease-out-cubic' });
  }, []);

  useEffect(() => {
    // Auto-play carousel
    const interval = setInterval(() => {
      if (!isPaused) {
        setCurrentCompetitor((prev) => (prev + 1) % competitors.length);
      }
    }, 5000);

    return () => clearInterval(interval);
  }, [competitors.length, isPaused]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 700);
    };
    
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleImageClick = (link) => {
    if (link) {
      window.open(link, '_blank');
    }
  };

  const handleCarouselInteraction = () => {
    setIsPaused(true);
    // Resume auto-play after 10 seconds of no interaction
    setTimeout(() => setIsPaused(false), 10000);
  };

  const handleFeatureSelect = (featureName) => {
    setSelectedFeature(featureName);
    setExpandedFeature(featureName);
    const featureData = features.find(f => f.name === featureName);
    // If the selected feature doesn't have user flow, switch to wireframes
    if (!featureData.userflow) {
      setActiveTab('wireframes');
    }
  };

  return (
    <div className="jerry-page">
      <Navbar />
      {/* Progress indicator */}
      <div className="jerry-progress-indicator">
        <div ref={progressRef} style={{ width: '100%', height: 0 }}></div>
      </div>
      <div className="jerry-progress-indicator-mobile">
        <div ref={progressMobileRef} style={{ width: 0 }}></div>
      </div>

      {/* Banner */}
      <img src={Banner} alt="Jerry The Junior Researcher Banner" className="jerry-header" data-aos="fade-up" />

      <div className="jerry-content">
        {/* Overview Section */}
        <section data-aos="fade-up" className="jerry-overview-section">
          <h2>OVERVIEW</h2>
          
          <div className="jerry-problem-statement">
            <h3>Problem Statement</h3>
            <p>Research in various fields struggles with messy data, participant management challenges, and the hassle of handling resources across different platforms. The current tools lack simplicity and integration, slowing down the research process. That's where Jerry The Junior Researcher comes in. By offering a straightforward platform that merges research materials, optimizes participant coordination, and promotes teamwork, Jerry aims to revolutionize research management, making it a breeze for everyone involved.</p>
          </div>

          <div className="jerry-team-info">
            <div className="jerry-info-item">
              <strong>Team: </strong>Product Designers - 2
            </div>
            <div className="jerry-info-item">
              <strong>Project Timeline: </strong>
              July 27 2023 - Aug 15 2023
            </div>
          </div>

          <div className="jerry-our-story">
            <h3>Our Story</h3>
            <p>Our journey began where academia meets real-world research. Inspired by a mix of academic exploration and practical experience, we uncovered a common challenge that researchers across fields faced – managing their studies efficiently. This realization hit us during a cross-disciplinary academic project and a stint at ASU's Psychology Department. From psychology to education technology, researchers struggled with scattered data, resource chaos, and the complexities of study coordination. In response, we hatched an idea that would change the game – an all-in-one digital hub called "Jerry The Junior Researcher."</p>
            <p>At its core, Jerry aimed to simplify research. We envisioned a platform that would erase the boundaries between different fields and make research smoother. We focused on making it super user-friendly and practical. With Jerry, researchers could effortlessly bring together materials, participants, and tasks. The goal? To give all researchers a simple yet powerful tool to collect data, collaborate with ease, and manage participants efficiently. Through Jerry, we wanted to bid farewell to the headaches of scattered work and welcome a new era of streamlined, effective research management.</p>
          </div>
        </section>

        {/* Product Preview Section */}
        <section data-aos="fade-up" className="jerry-product-preview">
          <h2>PRODUCT PREVIEW</h2>
          <div className="jerry-video-container">
            <iframe
              width="100%"
              height="400"
              src="https://www.youtube.com/embed/PLd3_AosQOQ"
              title="Jerry The Junior Researcher Product Preview"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </section>

        {/* Competitors Section */}
        <section data-aos="fade-up" className="jerry-competitors-section">
          <h2>COMPETITORS</h2>
          <p className="jerry-competitors-subtitle">Like what you see? Guess who else works in this space?</p>
          
          <div className="jerry-competitors-carousel">
            <div className="jerry-carousel-container">
              <div 
                className="jerry-carousel-track"
                style={{ transform: `translateX(-${currentCompetitor * 100}%)` }}
              >
                {competitors.map((competitor, index) => (
                  <div key={index} className="jerry-carousel-slide">
                    <img src={competitor.image} alt={competitor.name} />
                  </div>
                ))}
              </div>
              
              <button 
                className="jerry-carousel-btn jerry-carousel-prev"
                onClick={() => {
                  setCurrentCompetitor((prev) => 
                    prev === 0 ? competitors.length - 1 : prev - 1
                  );
                  handleCarouselInteraction();
                }}
                aria-label="Previous competitor"
              >
                ‹
              </button>
              
              <button 
                className="jerry-carousel-btn jerry-carousel-next"
                onClick={() => {
                  setCurrentCompetitor((prev) => 
                    (prev + 1) % competitors.length
                  );
                  handleCarouselInteraction();
                }}
                aria-label="Next competitor"
              >
                ›
              </button>
            </div>
            
            <div className="jerry-carousel-dots">
              {competitors.map((_, index) => (
                <button
                  key={index}
                  className={`jerry-carousel-dot ${index === currentCompetitor ? 'active' : ''}`}
                  onClick={() => {
                    setCurrentCompetitor(index);
                    handleCarouselInteraction();
                  }}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </section>

        {/* Project Planning Section */}
        <section data-aos="fade-up" className="jerry-planning-section">
          <h2>PROJECT PLANNING</h2>
          <div className="jerry-planning-flow">
            <div className="jerry-planning-step">
              <div className="jerry-planning-circle">
                <span>Plan</span>
              </div>
              <p><strong>Phase 1:</strong> To facilitate seamless Collaboration, Scheduling, and onboarding</p>
            </div>
            <div className="jerry-planning-arrow"></div>
            <div className="jerry-planning-step">
              <div className="jerry-planning-circle">
                <span>Conduct</span>
              </div>
              <p><strong>Phase 2:</strong> To create a platform to conduct the test in-app with software integrations</p>
            </div>
            <div className="jerry-planning-arrow"></div>
            <div className="jerry-planning-step">
              <div className="jerry-planning-circle">
                <span>Record</span>
              </div>
              <p><strong>Phase 3:</strong> To create a space where the metrics can be recorded with minimal effort</p>
            </div>
            <div className="jerry-planning-arrow"></div>
            <div className="jerry-planning-step">
              <div className="jerry-planning-circle">
                <span>Visualise</span>
              </div>
              <p><strong>Phase 4:</strong> To analyse and understand the results through Data Visualisation</p>
            </div>
          </div>
        </section>

        {/* Information Architecture Section */}
        <section data-aos="fade-up" className="jerry-architecture-section">
          <h2>INFORMATION ARCHITECTURE</h2>
          <p>We had many ideas, but we needed to organize our thoughts and bring clarity. Our solution was to design a clear, well-structured information architecture that could accommodate everything effectively.</p>
          <div className="jerry-architecture-images">
            <img 
              src={InformationArchitecture} 
              alt="Information Architecture" 
              onClick={() => handleImageClick('https://www.figma.com/board/kLqcXAEZtQ7mgJ8zmlX1wI/Jerry_publish?node-id=78-490&t=vHJHqgk8fIXj9ZGn-4')}
              className="jerry-clickable-image"
            />
          </div>
          <p className="jerry-architecture-subtitle">Click on the image below to access the full FigJam board</p>
        </section>

        {/* Features Section */}
        <section data-aos="fade-up" className="jerry-features-section">
          <h2>FEATURES</h2>
          <p>Once we had the flow in place we wanted to understand each feature in a deeper sense, we designed a user flow and then we worked on our mid-fidelity wireframes.</p>
          
          <div className="jerry-features-container">
            {/* Left Column - Feature List */}
            <div className="jerry-features-list">
              {features.map((feature) => (
                <div key={feature.name} className="jerry-feature-accordion-item">
                <button
                  className={`jerry-feature-item ${selectedFeature === feature.name ? 'active' : ''}`}
                    onClick={() => handleFeatureSelect(feature.name)}
                >
                  {feature.name}
                </button>

                  {/* Mobile Accordion Content */}
                  {isMobile && (
                    <div className={`jerry-feature-mobile-content ${expandedFeature === feature.name ? 'expanded' : ''}`}>
              <div className="jerry-feature-tabs">
                        {feature.wireframe && (
                          <button
                            className={`jerry-tab ${activeTab === 'wireframes' ? 'active' : ''}`}
                            onClick={() => setActiveTab('wireframes')}
                          >
                            Wireframes
                          </button>
                        )}
                        {feature.userflow && (
                <button
                  className={`jerry-tab ${activeTab === 'userflow' ? 'active' : ''}`}
                  onClick={() => setActiveTab('userflow')}
                >
                  User Flow
                </button>
                        )}
                      </div>

                      <div className="jerry-feature-content">
                        {activeTab === 'userflow' && feature.userflow && (
                          <div className="jerry-userflow-container">
                            <img 
                              src={feature.userflow} 
                              alt={`${feature.name} User Flow`}
                              onClick={() => handleImageClick(feature.figjamLink)}
                              className="jerry-clickable-image"
                            />
                          </div>
                        )}
                        {activeTab === 'wireframes' && feature.wireframe && (
                          <div className="jerry-wireframe-container">
                            <img 
                              src={feature.wireframe} 
                              alt={`${feature.name} Wireframe`}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Desktop Feature Details */}
            {!isMobile && (
              <div className="jerry-feature-details">
                <div className="jerry-feature-tabs">
                  {selectedFeatureData.wireframe && (
                <button
                  className={`jerry-tab ${activeTab === 'wireframes' ? 'active' : ''}`}
                  onClick={() => setActiveTab('wireframes')}
                >
                  Wireframes
                </button>
                  )}
                  {selectedFeatureData.userflow && (
                    <button
                      className={`jerry-tab ${activeTab === 'userflow' ? 'active' : ''}`}
                      onClick={() => setActiveTab('userflow')}
                    >
                      User Flow
                    </button>
                  )}
              </div>

              <div className="jerry-feature-content">
                {activeTab === 'userflow' && selectedFeatureData.userflow && (
                  <div className="jerry-userflow-container">
                    <img 
                      src={selectedFeatureData.userflow} 
                      alt={`${selectedFeature} User Flow`}
                      onClick={() => handleImageClick(selectedFeatureData.figjamLink)}
                      className="jerry-clickable-image"
                    />
                  </div>
                )}
                  {activeTab === 'wireframes' && selectedFeatureData.wireframe && (
                  <div className="jerry-wireframe-container">
                    <img 
                      src={selectedFeatureData.wireframe} 
                      alt={`${selectedFeature} Wireframe`}
                    />
                  </div>
                )}
              </div>
            </div>
            )}
          </div>
        </section>

        {/* Design System Section */}
        <section data-aos="fade-up" className="jerry-design-system-section">
          <h2>DESIGN SYSTEM</h2>
          <p>Integrated seamlessly into our project, Google's Material Design 3 color and typography systems serve a dual role. Rooted in extensive research and immaculately documented, these systems optimize visual appeal and inclusivity. The color system harmonizes aesthetics with accessibility, while the typography system ensures readability and consistency for diverse users. This integration elevates our interface, embodying our dedication to superior design.</p>
          <img src={DesignSystem} alt="Design System" className="jerry-design-system-img" />
        </section>

        {/* Key Learnings Section */}
        <section data-aos="fade-up" className="jerry-learnings-section">
          <h2>KEY LEARNINGS</h2>
          <ul>
            <li>Creating an information architecture after addressing the key requirements allowed us to explore the scope of the project and expand it depending on the need.</li>
            <li>Looking at the project through a developer's perspective gave us a chance to dive deep and discover a major blocker that prevented us from implementing most of our features. We expanded our project scope and found an alternative to implement our features. This helped us stay practical and design realistic solutions.</li>
            <li>Understanding and creating a design system allowed us to collaborate and establish homogeneity in our designs while working asynchronously.</li>
            <li>Exploring the ongoing trends helped us stay on track with the existing community mental models.</li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default Jerry; 